const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Récupérer les détails d'un lieu par son ID
export const getPlaceDetails = async (placeId) => {
  try {
    console.log(`Getting details for place: ${placeId}`);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 seconds timeout

    const response = await fetch(`${API_URL}/places/place/${placeId}`, {
      signal: controller.signal,
      headers: {
        Accept: 'application/json',
      },
    });

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Failed to get place details: ${response.status}`);
    }

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      throw new Error(`Invalid JSON response from API (starts with: ${text.slice(0, 50)})`);
    }

    // Ensure all required fields are present
    const formattedData = {
      name: data.name || '',
      address: data.address || '',
      place_id: placeId,
      current_popularity:
        typeof data.current_popularity === 'number' ? data.current_popularity : null,
      business_status: data.business_status || 'OPERATIONAL',
      is_open: typeof data.is_open === 'boolean' ? data.is_open : true,
    };

    // Validate required fields
    if (!formattedData.name || !formattedData.address) {
      throw new Error('Invalid place data received from API');
    }

    return formattedData;
  } catch (error) {
    console.error('Error in getPlaceDetails:', error);
    throw error;
  }
};

export const getNearbyPlaces = async (lat, lng, radius = 1500) => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(
      `${API_URL}/places/nearby?lat=${lat}&lng=${lng}&radius=${radius}`,
      {
        signal: controller.signal,
        headers: { Accept: 'application/json' },
      }
    );

    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Failed to get nearby places: ${response.status}`);
    }

    const text = await response.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      throw new Error(`Invalid JSON from nearby API (starts with: ${text.slice(0, 50)})`);
    }
    return data.results || [];
  } catch (error) {
    console.error('Error in getNearbyPlaces:', error);
    throw error;
  }
};
